import { defineStore } from 'pinia'

import type { UpsellBannerStore } from './interfaces'

import { actions } from './actions'
import { getters } from './getters'

export const useUpsellBannerStore = defineStore('upsell-banner', {
  state: (): UpsellBannerStore => ({
    banner: null,
    loading: false,
  }),
  actions,
  getters,
})
